<template>
    <div >
      <BaseModal
        v-if="visible"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :TitleWindow="$t('ChargeSheet.AddProcedures')"
        :UseScroll="true"
        :width="'40%'"
        :height="'auto'"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.TitleOK'), variant: 'primary', action: onClick },
        ]"
        @Close="close"
        >
        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.doctorCode"
                v-bind:ModelDescription="doctorDesc"
                v-bind:Label="$tc('Shared.DoctorName')"
                v-bind:RefCode="'Doctor'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiDoctors"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('Shared.DoctorName')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isDoctorValid"
                :SearchFieldCode="'code'"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.principalCpt"
                v-bind:ModelDescription="princDesc"
                v-bind:Label="$tc('Shared.Principal')"
                v-bind:RefCode="'Principal'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isPrincipalValid"
                :SearchFieldCode="'Code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.principalCptdate"
              @input="detailData.principalCptdate = $event; isDatePrincipalValid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDatePrincipalValid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other1Cpt"
                v-bind:ModelDescription="other1Desc"
                v-bind:Label="$tc('ChargeSheet.Other1')"
                v-bind:RefCode="'Other1'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther1Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other1Cptdate"
              @input="detailData.other1Cptdate = $event; isDateOther1Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther1Valid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other2Cpt"
                v-bind:ModelDescription="other2Desc"
                v-bind:Label="$tc('ChargeSheet.Other2')"
                v-bind:RefCode="'Other2'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther2Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other2Cptdate"
              @input="detailData.other2Cptdate = $event; isDateOther2Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther2Valid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other3Cpt"
                v-bind:ModelDescription="other3Desc"
                v-bind:Label="$tc('ChargeSheet.Other3')"
                v-bind:RefCode="'Other3'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther3Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other3Cptdate"
              @input="detailData.other3Cptdate = $event; isDateOther3Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther3Valid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other4Cpt"
                v-bind:ModelDescription="other4Desc"
                v-bind:Label="$tc('ChargeSheet.Other4')"
                v-bind:RefCode="'Other4'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther4Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other4Cptdate"
              @input="detailData.other4Cptdate = $event; isDateOther4Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther4Valid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other5Cpt"
                v-bind:ModelDescription="other5Desc"
                v-bind:Label="$tc('ChargeSheet.Other5')"
                v-bind:RefCode="'Other5'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther5Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other5Cptdate"
              @input="detailData.other5Cptdate = $event; isDateOther5Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther5Valid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other6Cpt"
                v-bind:ModelDescription="other6Desc"
                v-bind:Label="$tc('ChargeSheet.Other6')"
                v-bind:RefCode="'Other6'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther6Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other6Cptdate"
              @input="detailData.other6Cptdate = $event; isDateOther6Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther6Valid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other7Cpt"
                v-bind:ModelDescription="other7Desc"
                v-bind:Label="$tc('ChargeSheet.Other7')"
                v-bind:RefCode="'Other7'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther7Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other7Cptdate"
              @input="detailData.other7Cptdate = $event; isDateOther7Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther7Valid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other8Cpt"
                v-bind:ModelDescription="other8Desc"
                v-bind:Label="$tc('ChargeSheet.Other8')"
                v-bind:RefCode="'Other8'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther8Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other8Cptdate"
              @input="detailData.other8Cptdate = $event; isDateOther8Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther8Valid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other9Cpt"
                v-bind:ModelDescription="other9Desc"
                v-bind:Label="$tc('ChargeSheet.Other9')"
                v-bind:RefCode="'Other9'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther9Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other9Cptdate"
              @input="detailData.other9Cptdate = $event; isDateOther9Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther9Valid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other10Cpt"
                v-bind:ModelDescription="other10Desc"
                v-bind:Label="$tc('ChargeSheet.Other10')"
                v-bind:RefCode="'Other10'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther10Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other10Cptdate"
              @input="detailData.other10Cptdate = $event; isDateOther10Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther10Valid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other11Cpt"
                v-bind:ModelDescription="other11Desc"
                v-bind:Label="$tc('ChargeSheet.Other11')"
                v-bind:RefCode="'Other11'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther11Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other11Cptdate"
              @input="detailData.other11Cptdate = $event; isDateOther11Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther11Valid">
            </MdDateTime>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="8" md="8" sm="8">
            <MdLookup
                v-bind:ModelCode="detailData.other12Cpt"
                v-bind:ModelDescription="other12Desc"
                v-bind:Label="$tc('ChargeSheet.Other12')"
                v-bind:RefCode="'Other12'"
                v-bind:Fields="ProcceduresFields"
                v-bind:Api="this.ApiProcedures"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('ChargeSheet.AddProcedures')"
                :GetValues="onCodeConditionOk"
                v-bind:isRequired="true"
                v-bind:isValid="isOther12Valid"
                :SearchFieldCode="'code'"
            />
          </b-col>
          <b-col lg="4" md="4" sm="4">
            <MdDateTime
              :Label="$t('Shared.Date')"
              :Model="detailData.other12Cptdate"
              @input="detailData.other12Cptdate = $event; isDateOther12Valid = true"
              :Type="'date'"
              :isRequired="true"
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateOther12Valid">
            </MdDateTime>
          </b-col>
        </b-row>
      </BaseModal>
     </div>
</template>

<script>
    import Vue from 'vue'
    import Utils from '@/common/utils'
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import InpatientProcService from '@/services/InpatientProc.service'
    import ChargeSheetService from '@/services/chargesheet.service'
    import DoctorService from '@/services/doctor.service'

    export default Vue.extend({
        name: "ModalAddProcedures",
        mixins: [ ShowMessage ],
        props: {
          recordId: String,
          admissionADMITDATE: String,
          admissionDischargeDate: String,
          closeWindow: Function,
          visible: {
            type: Boolean,
            default: false
          },
        },
        data() {
            return {
              modalId: 'Admissions',
              emitCloseEvent: false,
              ApiProcedures: "ChargeSheet/ICD9Procedures",
              ApiDoctors: 'Doctors',
              ProcceduresFields:[
                { key: 'code', sortable: true, label: this.$t('Shared.Code')},
                { key: 'name', sortable: true, label: this.$t('Shared.Description') },
              ],

              isDoctorValid: true,
              doctorDesc: null,

              isDatePrincipalValid: true,
              isPrincipalValid: true,
              princDesc: null,

              isDateOther1Valid: true,
              isOther1Valid: true,
              other1Desc: null,

              isDateOther2Valid: true,
              isOther2Valid: true,
              other2Desc: null,

              isDateOther3Valid: true,
              isOther3Valid: true,
              other3Desc: null,

              isDateOther4Valid: true,
              isOther4Valid: true,
              other4Desc: null,

              isDateOther5Valid: true,
              isOther5Valid: true,
              other5Desc: null,

              isDateOther6Valid: true,
              isOther6Valid: true,
              other6Desc: null,

              isDateOther7Valid: true,
              isOther7Valid: true,
              other7Desc: null,

              isDateOther8Valid: true,
              isOther8Valid: true,
              other8Desc: null,

              isDateOther9Valid: true,
              isOther9Valid: true,
              other9Desc: null,

              isDateOther10Valid: true,
              isOther10Valid: true,
              other10Desc: null,

              isDateOther11Valid: true,
              isOther11Valid: true,
              other11Desc: null,

              isDateOther12Valid: true,
              isOther12Valid: true,
              other12Desc: null,

              detailData: {
                "recordId": null,
                "principalCpt": null,
                "principalCptdate": null,
                "other1Cpt": null,
                "other1Cptdate": null,
                "other2Cpt": null,
                "other2Cptdate": null,
                "other3Cpt": null,
                "other3Cptdate": null,
                "other4Cpt": null,
                "other4Cptdate": null,
                "other5Cpt": null,
                "other5Cptdate": null,
                "doctorCode": null,
                "other6Cpt": null,
                "other6Cptdate": null,
                "other7Cpt": null,
                "other7Cptdate": null,
                "other8Cpt": null,
                "other8Cptdate": null,
                "other9Cpt": null,
                "other9Cptdate": null,
                "other10Cpt": null,
                "other10Cptdate": null,
                "other11Cpt": null,
                "other11Cptdate": null,
                "other12Cpt": null,
                "other12Cptdate": null
                },
              isEditMode: false
            }
        },
        watch: {
          visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
          },
        },
        methods: {

          getAllDescription(){
            if(this.detailData.principalCpt != '' || this.detailData.principalCpt != null){
                this.getDescriptionByConditionCode(this.detailData.principalCpt,'Principal');
            }if(this.detailData.other1Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other1Cpt,'Other1');
            }if(this.detailData.other2Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other2Cpt,'Other2');
            }if(this.detailData.other3Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other3Cpt,'Other3');
            }if(this.detailData.other4Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other4Cpt,'Other4');
            }if(this.detailData.other5Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other5Cpt,'Other5');
            }if(this.detailData.other6Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other6Cpt,'Other6');
            }if(this.detailData.other7Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other7Cpt,'Other7');
            }if(this.detailData.other8Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other8Cpt,'Other8');
            }if(this.detailData.other9Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other9Cpt,'Other9');
            }if(this.detailData.other10Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other10Cpt,'Other10');
            }if(this.detailData.other11Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other11Cpt,'Other11');
            }if(this.detailData.other12Cpt != ''){
                this.getDescriptionByConditionCode(this.detailData.other12Cpt,'Other12');
            }if(this.detailData.doctorCode != ''){
                this.getDescriptionByDoctor(this.detailData.doctorCode);
            }
        },

          getDescriptionByConditionCode(Code,ConditionNumber){

           if(Code != null && Code != ''){
           ChargeSheetService.getChargeSheetGetICD9(Code)
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){
                        this.TempConditionByCode = response.data;
                      switch (ConditionNumber) {
                            case "Principal":
                                this.princDesc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            case "Other1":
                                this.other1Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            case "Other2":
                                this.other2Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            case "Other3":
                                this.other3Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            case "Other4":
                                this.other4Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            case "Other5":
                                this.other5Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            case "Other6":
                                this.other6Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            case "Other7":
                                this.other7Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            case "Other8":
                                this.other8Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            case "Other9":
                                this.other9Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            case "Other10":
                                this.other10Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            case "Other11":
                                this.other11Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                                break;
                            default:
                                this.other12Desc = this.TempConditionByCode[0] ? this.TempConditionByCode[0].name : null;
                      }
                    }
                 })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
           }

        },

        getDescriptionByDoctor(Code){
           if(Code != null && Code != ''){
           DoctorService.get(Code)
                .then((response) => {
                    if(response.status == '200' && response.data){
                      this.doctorDesc = response.data ? `${response.data.firstname} ${response.data.lastname}` : null;
                    }
                 })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
           }
        },

            onCodeConditionOk(data) {
                let fieldName = data.FieldName
                switch (fieldName) {
                    case "Doctor":
                        this.detailData.doctorCode = data.code ? data.code : null;
                        break;
                    case "Principal":
                        this.detailData.principalCpt = data.code ? data.code : null;
                        break;
                    case "Other1":
                        this.detailData.other1Cpt = data.code ? data.code : null;
                        break;
                    case "Other2":
                        this.detailData.other2Cpt = data.code ? data.code : null;
                        break;
                    case "Other3":
                        this.detailData.other3Cpt = data.code ? data.code : null;
                        break;
                    case "Other4":
                        this.detailData.other4Cpt = data.code ? data.code : null;
                        break;
                    case "Other5":
                        this.detailData.other5Cpt = data.code ? data.code : null;
                        break;
                    case "Other6":
                        this.detailData.other6Cpt = data.code ? data.code : null;
                        break;
                    case "Other7":
                        this.detailData.other7Cpt = data.code ? data.code : null;
                        break;
                    case "Other8":
                        this.detailData.other8Cpt = data.code ? data.code : null;
                        break;
                    case "Other9":
                        this.detailData.other9Cpt = data.code ? data.code : null;
                        break;
                    case "Other10":
                        this.detailData.other10Cpt = data.code ? data.code : null;
                        break;
                    case "Other11":
                        this.detailData.other11Cpt = data.code ? data.code : null;
                        break;
                    default:
                        this.detailData.other12Cpt = data.code ? data.code : null;
                }
            },

            async updateInpatientProc(){
                this.$emit('load', true)
                await InpatientProcService.updateInpatientProc(this.recordId, this.detailData)
                .then((response) => {
                    if(response.status == '200' && response.data){
                      //
                      this.$emit('load', false)
                    }
                 })
                .catch((error) => {
                    this.$emit('load', false)
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
            },

            async addInpatientProc(){
                this.$emit('load', true)
                this.detailData.recordId = this.recordId
                await InpatientProcService.addInpatientProc(this.detailData)
                .then((response) => {
                    if(response.status == '200' && response.data){
                      //
                      this.$emit('load', false)
                    }
                 })
                .catch((error) => {
                    this.$emit('load', false)
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
            },

            onClick() {
                if (this.validateForm()) {
                    if (this.isEditMode) {
                        this.updateInpatientProc()
                    } else {
                        this.addInpatientProc()
                    }
                    if (this.visible) this.onHidden();
                }
            },


            close() {
              this.emitEventCancel();
            },

            valueNoEmpty(value) {
                return value !== null && value !== undefined && value.toString().trim() !== '';
            },

            valueEmpty(value) {
                return value == null || value == undefined || value.toString().trim() == '';
            },

            validateDate(field1,field2,code,date) {
                let ret = this.valueNoEmpty(code) && this.valueEmpty(date)
                if (ret) this.showMessage(this.$tc('Msg.Error'),this.$t('ChargeSheet.ValidMsg', { field1: field1, field2: field2 }),"error");
                return ret
            },

            validateCode(field1,field2,code,date) {
                let ret = this.valueEmpty(code) && this.valueNoEmpty(date)
                if (ret) this.showMessage(this.$tc('Msg.Error'),this.$t('ChargeSheet.ValidMsg', { field2: field1, field1: field2 }),"error");
                return ret
            },

            validateDateRange(date) {
                let ret = this.valueNoEmpty(date) && Utils.isValidDateAndRangeWith(date,this.admissionADMITDATE,this.admissionDischargeDate)
                if (!ret) this.showMessage(this.$tc('Msg.Error'),this.$t('ChargeSheet.ValidMsgDate'),"error");
                return ret
            },

            validateForm() {
              if (this.validateDate('date','Principal',this.detailData.principalCpt,this.detailData.principalCptdate)) {
                this.isDatePrincipalValid = false
                return false
              }
              if (this.validateDate('date','Other1',this.detailData.other1Cpt,this.detailData.other1Cptdate)) {
                this.isDateOther1Valid = false
                return false
              }
              if (this.validateDate('date','Other2',this.detailData.other2Cpt,this.detailData.other2Cptdate)) {
                this.isDateOther2Valid = false
                return false
              }
              if (this.validateDate('date','Other3',this.detailData.other3Cpt,this.detailData.other3Cptdate)) {
                this.isDateOther3Valid = false
                return false
              }
              if (this.validateDate('date','Other4',this.detailData.other4Cpt,this.detailData.other4Cptdate)) {
                this.isDateOther4Valid = false
                return false
              }
              if (this.validateDate('date','Other5',this.detailData.other5Cpt,this.detailData.other5Cptdate)) {
                this.isDateOther5Valid = false
                return false
              }
              if (this.validateDate('date','Other6',this.detailData.other6Cpt,this.detailData.other6Cptdate)) {
                this.isDateOther6Valid = false
                return false
              }
              if (this.validateDate('date','Other7',this.detailData.other7Cpt,this.detailData.other7Cptdate)) {
                this.isDateOther7Valid = false
                return false
              }
              if (this.validateDate('date','Other8',this.detailData.other8Cpt,this.detailData.other8Cptdate)) {
                this.isDateOther8Valid = false
                return false
              }
              if (this.validateDate('date','Other9',this.detailData.other9Cpt,this.detailData.other9Cptdate)) {
                this.isDateOther9Valid = false
                return false
              }
              if (this.validateDate('date','Other10',this.detailData.other10Cpt,this.detailData.other10Cptdate)) {
                this.isDateOther10Valid = false
                return false
              }
              if (this.validateDate('date','Other11',this.detailData.other11Cpt,this.detailData.other11Cptdate)) {
                this.isDateOther11Valid = false
                return false
              }
              if (this.validateDate('date','Other12',this.detailData.other12Cpt,this.detailData.other12Cptdate)) {
                this.isDateOther12Valid = false
                return false
              }

              if (this.validateCode('date','Principal',this.detailData.principalCpt,this.detailData.principalCptdate)) {
                this.isPrincipalValid = false
                return false
              }
              if (this.validateCode('date','Other1',this.detailData.other1Cpt,this.detailData.other1Cptdate)) {
                this.isOther1Valid = false
                return false
              }
              if (this.validateCode('date','Other2',this.detailData.other2Cpt,this.detailData.other2Cptdate)) {
                this.isOther2Valid = false
                return false
              }
              if (this.validateCode('date','Other3',this.detailData.other3Cpt,this.detailData.other3Cptdate)) {
                this.isOther3Valid = false
                return false
              }
              if (this.validateCode('date','Other4',this.detailData.other4Cpt,this.detailData.other4Cptdate)) {
                this.isOther4Valid = false
                return false
              }
              if (this.validateCode('date','Other5',this.detailData.other5Cpt,this.detailData.other5Cptdate)) {
                this.isOther5Valid = false
                return false
              }
              if (this.validateCode('date','Other6',this.detailData.other6Cpt,this.detailData.other6Cptdate)) {
                this.isOther6Valid = false
                return false
              }
              if (this.validateCode('date','Other7',this.detailData.other7Cpt,this.detailData.other7Cptdate)) {
                this.isOther7Valid = false
                return false
              }
              if (this.validateCode('date','Other8',this.detailData.other8Cpt,this.detailData.other8Cptdate)) {
                this.isOther8Valid = false
                return false
              }
              if (this.validateCode('date','Other9',this.detailData.other9Cpt,this.detailData.other9Cptdate)) {
                this.isOther9Valid = false
                return false
              }
              if (this.validateCode('date','Other10',this.detailData.other10Cpt,this.detailData.other10Cptdate)) {
                this.isOther10Valid = false
                return false
              }
              if (this.validateCode('date','Other11',this.detailData.other11Cpt,this.detailData.other11Cptdate)) {
                this.isOther11Valid = false
                return false
              }
              if (this.validateCode('date','Other12',this.detailData.other12Cpt,this.detailData.other12Cptdate)) {
                this.isOther12Valid = false
                return false
              }
              if (!this.validateDateRange(this.detailData.principalCptdate)) {
                this.isDatePrincipalValid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other1Cptdate)) {
                this.isDateOther1Valid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other2Cptdate)) {
                this.isDateOther2Valid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other3Cptdate)) {
                this.isDateOther3Valid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other4Cptdate)) {
                this.isDateOther4Valid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other5Cptdate)) {
                this.isDateOther5Valid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other6Cptdate)) {
                this.isDateOther6Valid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other7Cptdate)) {
                this.isDateOther7Valid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other8Cptdate)) {
                this.isDateOther8Valid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other9Cptdate)) {
                this.isDateOther9Valid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other10Cptdate)) {
                this.isDateOther10Valid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other11Cptdate)) {
                this.isDateOther11Valid = false
                return false;
              }
              if (!this.validateDateRange(this.detailData.other12Cptdate)) {
                this.isDateOther12Valid = false
                return false;
              }
              return true
            },

            onHidden() {
                this.$emit('close');
                this.emitCloseEvent= false;
            },

            emitEventCancel() {
              this.emitCloseEvent= false;
              this.$emit('close');
            },

            async GetInpatientProc() {
                  this.$emit('load', true)

                  await InpatientProcService.getInpatientProc(this.recordId)

                 .then((response) => {
                    if(response.status == '200'){
                        this.detailData = response.data;
                        this.isEditMode = true
                    }
                    else if(response.status == '204'){
                        this.isEditMode = false
                    }
                      this.$emit('load', false);
                  }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },
        },

        async mounted () {
            await this.GetInpatientProc()
            this.getAllDescription()
        },
    })
</script>
<style>

</style>
